function select_related_check_boxes(element, value) {
  const elemObj = $("#" + element);
  const categoryDiv = elemObj.closest("div[id*=cards_entities]");
  const options = categoryDiv.find("div");
  const head = options.first().children();

  if (elemObj[0] == head[0] && value == head.val()) {
    if (elemObj.is(":checked")) {
      categoryDiv.find(":checkbox").prop("checked", true);
    } else {
      categoryDiv.find(":checkbox").prop("checked", false);
    }
  } else if (elemObj.is(":checked")) {
    head.prop("checked", true);
  } else if (!elemObj.is(":checked")) {
    if (categoryDiv.find(":checkbox:checked").length == 1) {
      head.prop("checked", false);
    }
  }
}

$(document).ready(function () {
  $(document).on(
    "change",
    "#bus_cards_entities input[type=checkbox]",
    function () {
      select_related_check_boxes(this.id, this.value);
    }
  );
  $(document).on(
    "change",
    "#ph_cards_entities input[type=checkbox]",
    function () {
      select_related_check_boxes(this.id, this.value);
    }
  );
  $(document).on(
    "change",
    "#taxi_cards_entities input[type=checkbox]",
    function () {
      select_related_check_boxes(this.id, this.value);
    }
  );
});
